import React from 'react';
import { Form } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import styles from './form-components.module.scss';

interface FormFieldProps {
  label: string | React.ReactNode;
  children: React.ReactNode;
  messageId?: string;
  defaultMessage?: string;
  required?: boolean;
  helpText?: string | React.ReactNode;
}

/**
 * FormField - Standard form field wrapper with label
 * Provides consistent styling for form inputs, selects, etc.
 */
export const FormField: React.FC<FormFieldProps> = ({
  label,
  children,
  messageId,
  defaultMessage,
  required = false,
  helpText,
}) => {
  return (
    <Form.Group className={styles.formField}>
      <Form.Label className={styles.formField__label}>
        {messageId ? (
          <FormattedMessage id={messageId} defaultMessage={defaultMessage || label as string} />
        ) : (
          label
        )}
        {required && <span className={styles.formField__required}>*</span>}
      </Form.Label>
      {children}
      {helpText && (
        <Form.Text className={styles.formField__helpText}>
          {helpText}
        </Form.Text>
      )}
    </Form.Group>
  );
};

export default FormField;